exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rango1{background-color:#76be7c!important;color:#fff!important}.rango2{background-color:#d9ead3!important}.rango2,.rango3{color:rgba(65,64,64,.91)}.rango3{background-color:#fde8af!important}.rango4{background-color:#f5bc95!important}.rango4,.rango5{color:rgba(65,64,64,.91)}.rango5{background-color:#fda0a0!important}.rango0{background-color:#a5a5a5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-108d1734","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/climan/components/menuInterpretacion.vue
// module id = 1047
// module chunks = 2